/*
 * File: 目标管理-目标主表
 */
<template>
    <div class="main-report">
        <Paper class="main-report-paper">
            <list-layout-paper>
                <template slot="header-search">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        @search-change="mainReportList.searchList"
                    />
                </template>
                <template slot="header-button">
                    <lotsButton
                        v-has="authorityCode.import"
                        type="primary"
                        size="mini"
                        title="导入"
                        icon="el-icon-upload2"
                        @click="handleImport"
                    >导入</lotsButton>
                    <lotsButton
                        v-has="authorityCode.delete"
                        type="primary"
                        size="mini"
                        title="删除"
                        icon="el-icon-delete"
                        @click="handleDelete"
                    >删除</lotsButton>
                    <lotsButton
                        v-has="authorityCode.export"
                        type="primary"
                        size="mini"
                        title="导出"
                        icon="el-icon-download"
                        @click="handleExport"
                    >导出</lotsButton>
                    <el-tooltip effect="dark" content="列配置" placement="bottom">
                        <el-button icon="iconfont icon-list_install" type="primary" size="mini" @click="handleColumnConfig" plain />
                    </el-tooltip>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <table-box
                        ref="tableBoxRef"
                        :height="tableHeight"
                        :selection="config.selection"
                        :index="config.index"
                        :columns="config.columns"
                        :actions="config.actions"
                        v-loading="mainReportList.tableLoading"
                        :rows="mainReportList.totalData"
                        @selection-change="selectionChange"
                    />
                    <!-- 表格列配置弹框 -->
                    <column-config
                        ref="columnConfigRef"
                        :pageID="config.name"
                        :initColumns="config.columns"
                        @header-change="config.columns = $event"
                    />
                    <!-- 导入弹窗 -->
                    <addFileDialog
                        ref="fileDialogRef"
                        :config="config.importConfig"
                        @uploadSuccessHandle="mainReportList.getList()"
                        @uploadFailHandle="mainReportList.getList()"
                    />
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="mainReportList.sizeChange"
                        :current-page.sync="mainReportList.pageNo"
                        @current-change="mainReportList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="mainReportList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>
        </Paper>
    </div>
</template>

<script>
import { ref, reactive, onMounted, onActivated } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import _ from 'lodash';
import utils from '@/components/utils/common.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import lotsButton from '@/components/lots/lotsButton';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import columnConfig from '@/components/lots/columnConfig/Index';
import addFileDialog from '@/modules/mdm/components/addFileDialog/Index.vue';
import { getMainReportList, deleteMainReportList, exportMainReportList } from '@mdm/api/targetModdeules/mainReport.js';
import { config as configStatic } from './config';

export default {
    name: 'mainReport',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        lotsButton,
        tableBox,
        lotsPagination,
        columnConfig,
        addFileDialog
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.mainReport);
        const config = reactive(configStatic);
        const selectionList = ref([]);

        class AccountListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map((v) => ({
                        ...v,
                        goalValue: (v.goalValue || 0).toFixed(4),
                        actualValue: (v.actualValue || 0).toFixed(4),
                        completionRate: (v.completionRate || 0).toFixed(2)
                    }));
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.tableBoxRef.$refs.elTable.doLayout(); // 解决表格错位
                });
            };
        }
        const mainReportList = new AccountListClass({
            Api: {
                listApi: getMainReportList // 查询接口
            }
        });
        // 查询参数转换
        const searchDataFormat = (condition = {}, params = {}) => {
            if (condition.cycleEndDateFixed) {
                condition.cycleEndDateBegin = utils.formatDateTime(condition.cycleEndDateFixed[0]);
                condition.cycleEndDateEnd = utils.formatDateTime(condition.cycleEndDateFixed[1]);
                Reflect.deleteProperty(condition, 'cycleEndDateFixed');
            }
            if (condition.cycleStartDateFixed) {
                condition.cycleStartDateBegin = utils.formatDateTime(condition.cycleStartDateFixed[0]);
                condition.cycleStartDateEnd = utils.formatDateTime(condition.cycleStartDateFixed[1]);
                Reflect.deleteProperty(condition, 'cycleStartDateFixed');
            }

            const newParams = { ...condition, ...params };
            Object.keys(newParams).forEach(v => {
                if (newParams[v] === undefined || newParams[v] === null || newParams[v] === '') {
                    delete newParams[v];
                }
            });
            return newParams;
        };
        // 导入
        const handleImport = () => {
            setupContext.refs.fileDialogRef.openImport();
        };
        // 监听复选框选中
        const selectionChange = (selection) => {
            selectionList.value = selection;
        };
        // 删除
        const handleDelete = () => {
            if (!selectionList.value.length) {
                Message.warning('请至少选择一条记录');
                return;
            }
            MessageBox.confirm('删除后不可恢复，是否继续删除？', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const batchList = selectionList.value.map((v) => ({ id: v.id, manageKpiRelaId: v.manageKpiRelaId }));
                deleteMainReportList({ batchList }).then((res) => {
                    if (+res.code === 0) {
                        Message.success('删除成功');
                        mainReportList.getList();
                    }
                });
            });
        };
        // 导出
        const handleExport = async () => {
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = mainReportList.searchModel;
            const newData = _.cloneDeep(value); // 解决搜索参数被清空的问题
            const excelTitleList = otherUtils.sortColumnsByFixed(config.columns)?.map((item) => ({
                name: item.name,
                property: item.property
            }));
            const params = {
                ...searchDataFormat(newData),
                deleteFlag: 0,
                excelTitleList
            };
            exportMainReportList(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            });
        };
        // 列配置
        const handleColumnConfig = () => {
            setupContext.refs.columnConfigRef.show(true);
        };

        onActivated(() => {
            setupContext.refs.tableBoxRef.$refs.elTable.doLayout(); // 解决表格错位
        });
        onMounted(() => {
            setupContext.refs.searchBox.submitSearch();
        });

        return {
            config,
            authorityCode,
            mainReportList,
            handleImport,
            selectionChange,
            handleDelete,
            handleExport,
            handleColumnConfig
        };
    }
};
</script>

<style lang="less" >
.main-report {
    width: 100%;
    .main-report-paper {
        height: 100%;
    }
    .header-button {
        margin-left: 10px;
    }
    .search-box .el-select .el-input input {
        height: 28px!important;
    }
    .list-layout-wrapper {
        height: 100%;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }
    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .layout-content.main-report-paper {
        padding: 0px 0px 0px;
    }
}
</style>
